import React from 'react';
import {Link} from "react-router-dom";

import createLink from "../../../../libs/createLink";

import ContentLoader from "react-content-loader";
import DateSince from "../../../components/Date";
import Avatar from "../../../components/Avatar";
import Icon from "../../../components/Icon";
import DraftContentReader from "../../../components/editor/DraftContentReader";

const CommentToModerate = (props) => {
    return !props.commentsInitialized ? (
        <div className={`comment`}>
            <ContentLoader
                height={50}
                width={200}
                speed={2}
                ariaLabel={false}
                primaryColor="#f3f3f3"
                secondaryColor="#ecebeb"
            >
                <rect x="0" y="80" rx="3" ry="3" width="350" height="6.4"/>
                <rect x="0" y="100" rx="3" ry="3" width="380" height="6.4"/>
                <rect x="0" y="120" rx="3" ry="3" width="201" height="6.4"/>
                <circle cx="11.86" cy="17.97" r="8.86"/>
                <rect x="32.78" y="6.61" rx="10" ry="10" width="157.94" height="35.47"/>
            </ContentLoader>
        </div>
    ) : (
        <div className={`comment row`}>
            <div className="column full">
                <div className="author row">
                    <Avatar avatar={props.owner.profile.avatar} gender={props.owner.profile.gender}/>
                    <div className="author-infos row align-flex-end">
                            <span>Par&nbsp;
                                <Link to={createLink("userProfile", props.owner)}>
                                    {props.owner.username}
                                </Link>
                            </span>
                        &nbsp;
                        <DateSince
                            date={props.createdAt}
                            prefix={true}
                            currentFormat={true}
                        />
                    </div>
                    <div className="row ml-auto">
                            <span onClick={() => props.deleteCommentToModerate(props._id)}>
                                <Icon type="close"/>
                            </span>
                        <span onClick={() => props.acceptCommentToModerate(props._id,true)}>
                                <Icon type="check"/>
                            </span>
                    </div>
                </div>
                <div className="content">
                    <DraftContentReader contentRaw={props.contentRaw} />
                </div>
            </div>
        </div>
    )
}

export default CommentToModerate;